var _title;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLedger = function SvgLedger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96.69 23.76",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Ledger")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.7,0H7.59V12.29h12.3V3.18A3.18,3.18,0,0,0,16.7,0Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,0H3.18A3.18,3.18,0,0,0,0,3.18V4.75H4.75Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "0 7.59 4.75 7.59 4.75 12.34 0 12.34 0 7.59",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.18,19.89h1.57a3.18,3.18,0,0,0,3.18-3.19V15.18H15.18Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.59 15.18 12.34 15.18 12.34 19.93 7.59 19.93 7.59 15.18",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.18v1.57a3.18,3.18,0,0,0,3.18,3.18H4.75V15.18Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.03 1.27 30.17 1.27 30.17 18.66 40.02 18.66 40.02 17 32.03 17 32.03 1.27",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,5.88c-3.62,0-6.17,2.69-6.17,6.56v.44A6.35,6.35,0,0,0,46.14,19h.24A7.13,7.13,0,0,0,51,17.29l0-.05-.84-1.37-.09.05a5.47,5.47,0,0,1-3.68,1.47,4.6,4.6,0,0,1-4.7-4.75h9.4v-.1s0-.59,0-.88C51.18,8.13,49.13,5.88,46,5.88Zm-4.21,5.19a4.12,4.12,0,0,1,4.11-3.63c1.57,0,3.29.94,3.43,3.63Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,7.35V8a4.43,4.43,0,0,0-3.77-2.15H58c-3.33,0-5.63,2.64-5.63,6.51s2.2,6.57,5.48,6.57a4.58,4.58,0,0,0,4.17-2.26v1.91h1.76V1.27H62V7.35Zm-3.82,9.94c-2.3,0-3.82-2-3.82-4.9s1.61-4.85,3.87-4.85C60.1,7.54,62,9.06,62,12.39,62,16,60,17.29,58.14,17.29Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.55,7.59v.1c-.35-.59-1.42-1.86-4-1.86-3.28,0-5.44,2.5-5.44,6.32s2.26,6.41,5.59,6.41a4.16,4.16,0,0,0,3.87-2v1.72c0,2.4-1.52,3.77-4.22,3.77A7.3,7.3,0,0,1,67,21.26l-.09-.05-.69,1.52.1.05a9.26,9.26,0,0,0,4.06,1c2.89,0,6-1.47,6-5.54v-12H74.55V7.59ZM70.92,17c-2.4,0-4-1.86-4-4.75s1.37-4.61,3.72-4.61c2.59,0,3.82,1.52,3.82,4.61S73.27,17,70.92,17Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.76,5.88c-3.63,0-6.13,2.69-6.13,6.51v.44A6.37,6.37,0,0,0,84,19h.25a7.12,7.12,0,0,0,4.6-1.72l0,0L88,15.82l-.1,0a5.45,5.45,0,0,1-3.67,1.47,4.61,4.61,0,0,1-4.71-4.75H89v-.1s0-.59,0-.88C89,8.13,86.94,5.88,83.76,5.88Zm-4.17,5.19a4.13,4.13,0,0,1,4.12-3.63c1.56,0,3.28.94,3.42,3.63Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.64,6.12c-.25,0-.44,0-.69-.1a4.2,4.2,0,0,0-3.87,2.89V6.12H90.27l0,12.39v.1h1.86V13.37A7.77,7.77,0,0,1,92.52,11c.59-1.91,1.91-3.13,3.48-3.13a2.93,2.93,0,0,1,.59,0h.1V6.12Z",
    style: {
      fill: "white"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLedger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ledger.7398fa23.svg";
export { ForwardRef as ReactComponent };